<template>

    <div v-if="artist">

        <div class="artist-name">
            {{ artist.name }}
        </div>

        <div class="artist-tracks-count text-stardust-grey">
            {{ artist.trackcount }} Tracks.
        </div>


        <div class="form-group">

            <label for="projectFromEmailInput">
                Sender Email:
            </label>

            <input class="form-control" id="projectFromEmailInput" placeholder="me@example.com" v-model="fromEmail"/>

        </div>

        <div class="form-group">

            <label for="projectToEmailInput">
                Recipient Email (max. 3, comma-separated):
            </label>

            <input class="form-control" id="projectToEmailInput" placeholder="them@example.com" v-model="email" />

        </div>

		 <div class="form-group">

            <label for="emailNotesInput">
                Artist Notes:
            </label>

            <textarea class="form-control" id="emailNotesInput" placeholder="Email Notes (optional)" v-model="notes" cols="30" rows="7" />

        </div>

        <a class="btn btn-raised btn-xl font-weight-semibold share-button" v-bind:class="{ 'btn-success': sharing, 'btn-danger': !sharing }" href="#" v-on:click.prevent="emailArtist">
            <span v-if="!sharing">Share</span>
            <span v-if="sharing"><img src="/images/download-spinner.gif" alt="spinner" class="loading-icon">Sharing...</span>
        </a>

        <div class="form-group row">
            <div class="col-12">


                <label><br/><br/> <strong>Or</strong> share using the URL below</label>

                <textarea v-model="copiedArtistDetails" id="artistData" class="d-none"></textarea></div>
            <div class="col-sm-10">
                <input class="form-control" type="text" :value="copiedArtistDetails" readonly />
            </div>
            <div class="col-sm-2 copy-artist">
                <a href="#" class="btn btn-primary btn-block btn-sm copy-artist-details-button" v-bind:class="{ 'btn-success': copied }"
                   data-clipboard-action="copy" data-clipboard-target="#artistData">
                    <span v-if="!copied">Copy</span>
                    <span v-if="copied">Copied</span>
                </a>
            </div>
        </div>

    </div>

</template>

<script>

	import Vue from 'vue';
    import Clipboard from 'clipboard';
	import { playerService } from '../player-service';

	export default Vue.component(
	  'share-artist',
	  {

		  data: function () {

			  return {

				  artist: null,
				  notes: null,
				  email: null,
                  fromEmail: window.authenticatedUserEmail ? window.authenticatedUserEmail : '',
                  copiedArtistDetails: null,
                  clipboardPlugin: null,
                  copied: false,
                  sharing: false

			  };

		  },

		  mounted: function () {

              let ctx = this;

              playerService.$on( 'user-updated', () => {
                  this.fromEmail = window.authenticatedUserEmail ? window.authenticatedUserEmail : '';
              } );

              // Change the edit artist contents depending on whats passed to it.
			  playerService.$on(
				'share-artist',
				( artist ) => {

					// Update curr track for modal.
					this.artist = artist;

			  		this.reset();

					// Open the modal.
					window.webpackOpenBsModalWorkaround( '#shareArtistModal' );

                    // Setup the contents of the textarea.
                    this.copiedArtistDetails = this.getWindowUrl() + '/player?view-artist=' + this.artist.id;

                    if (this.clipboardPlugin) {
                        this.clipboardPlugin.destroy();
                    }

                    this.clipboardPlugin = new Clipboard('.copy-artist-details-button', {
                        container: document.getElementById('shareArtistModal'),
                        text: function (trigger) {
                            return ctx.copiedArtistDetails
                        }
                    });

                    this.copied = false;

                    this.sharing = false;

                    this.clipboardPlugin.on('success', function (e) {

                        ctx.copied = true;

                        e.clearSelection();
                    });

                    if(this.fromEmail) {
                        setTimeout(function() {
                            $('#projectFromEmailInput').attr('readonly', true);
                        }, 250);
                    }

				}
			  );

		  },

		  methods: {

		  	emailArtist: function() {

                this.sharing = true;

				playerService.emailArtist( this.artist, this.email, this.notes, this.fromEmail );

            },

		  	reset: function() {

				this.notes = null;
				this.email = null;

            },

            copy: function () {

                this.copied = true;

            },


            getWindowUrl: function () {
                if (!window.location.origin) {
                    window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
                }

                return window.location.origin;

            },

		  },

		  watch: {

			  artist: function( value ) {
				  this.reset();
			  }

		  }

	  }
	);

</script>
